module.exports = __webpack_public_path__ + "static/media/coverschoola.0970cee7.jpg";